
import { useState } from 'react';
import { usePaymentData } from '@/hooks/usePaymentData';
import { usePaymentCategoryManager } from '@/hooks/usePaymentCategoryManager';
import { usePaymentDateManager } from '@/hooks/usePaymentDateManager';
import { usePaymentInstructionsSender } from '@/hooks/usePaymentInstructionsSender';
import { PaymentDetails } from '@/types/payment';

export const useAdminPaymentManager = () => {
  const {
    categories,
    students,
    studentPayments,
    isLoading,
    setCategories,
    fetchStudentPayments,
    fetchStudents,
    refreshCategories
  } = usePaymentData();

  const [selectedStudent, setSelectedStudent] = useState<string>('');
  const [paymentDetails, setPaymentDetails] = useState<PaymentDetails>({
    category: '',
    subscriptionType: '1year',
    paymentPlan: '1'
  });

  const { updateCategory } = usePaymentCategoryManager();
  const { updatePaymentDates, deletePayment } = usePaymentDateManager();
  const { sendPaymentInstructions } = usePaymentInstructionsSender();

  const handleUpdateCategory = (categoryId: string, field: string, value: any) => {
    updateCategory(categoryId, field, value, setCategories);
  };

  const handleUpdatePaymentDates = (paymentId: string, startDate: string, endDate: string) => {
    updatePaymentDates(paymentId, startDate, endDate, fetchStudentPayments);
  };

  const handleDeletePayment = (paymentId: string) => {
    deletePayment(paymentId, fetchStudentPayments);
  };

  const handleSendPaymentInstructions = (studentId?: string) => {
    sendPaymentInstructions(
      studentId,
      selectedStudent,
      students,
      categories,
      paymentDetails,
      fetchStudentPayments,
      fetchStudents
    );
  };

  return {
    // Data
    categories,
    students,
    studentPayments,
    isLoading,
    selectedStudent,
    paymentDetails,
    
    // Actions
    setSelectedStudent,
    setPaymentDetails,
    updateCategory: handleUpdateCategory,
    updatePaymentDates: handleUpdatePaymentDates,
    deletePayment: handleDeletePayment,
    sendPaymentInstructions: handleSendPaymentInstructions,
    handleCategoriesChange: setCategories,
    fetchStudentPayments,
    fetchStudents,
    refreshCategories
  };
};
